import Chip from "@mui/material/Chip";
import { alpha } from "@mui/material/styles";

import { encampBrandColors } from "../colors";

export type ScoutTier = "pro" | "regulatory-advisor";

const TIER_CHIP_STYLES: Record<ScoutTier, { label: string; color: string }> = {
  pro: {
    label: "Pro",
    color: encampBrandColors.sapphire,
  },
  "regulatory-advisor": {
    label: "Regulatory Advisor",
    color: encampBrandColors.pumpkin,
  },
};

type ScoutTierChipProps = {
  tier: ScoutTier;
};

/**
 * Visual distinction between Scout tiers. Pro is brand teal (sapphire); Regulatory
 * Advisor is brand pumpkin. Outlined + soft fill matches the chip design-system
 * light-on-the-eyes pattern, using brand colors rather than MUI semantic roles.
 */
export function ScoutTierChip({ tier }: ScoutTierChipProps) {
  const { label, color } = TIER_CHIP_STYLES[tier];

  return (
    <Chip
      size="small"
      label={label}
      variant="outlined"
      sx={{
        color,
        borderColor: color,
        bgcolor: alpha(color, 0.08),
        height: 24,
        flexShrink: 0,
        "& .MuiChip-label": {
          px: 1,
        },
      }}
    />
  );
}
